/**
 * Returns an anonymous function that can be used to retrieve a certain data from the collection
 * based on the passed property value.
 * @param {Array} collection Collection of data.
 * @param {string} propertyName The property of a certain object to look for.
 * @returns {Function} A function that is used to find a certain data from the collection.
 */
export function collectionHelper(collection, propertyName) {
    const collections = [...collection] || [];

    /**
     * Retrieve a certain data from the collection based on the passed property value.
     * @returns {Object|undefined} The data that was retrieved from the collection otherwised undefined.
     */
    return function (propertyNameValue) {
        return collections.find(
            (item) => {
                if (item && !!item[propertyName]) {
                    return item[propertyName] === propertyNameValue;
                }
            }
        );
    };
}
